import { h } from "@stencil/core";
import { uniWatermark } from "../../../license";
export class UniTestMatComponent {
    connectedCallback() {
        uniWatermark('mat');
    }
    render() {
        return h("h1", null, h("slot", null));
    }
    static get is() { return "uni-test-mat"; }
}
//# sourceMappingURL=test-mat.component.js.map
